// @ts-nocheck
import React from "react";
import TabViewSelect from "../../TabViewSelect";
import ForecastSelect from "../../ForecastSelect";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download-02.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock-01.svg";
import { ReactComponent as DatasetsIcon } from "../../../assets/icons/layers-icon.svg";
import GraphVariationChips from "./GraphVariationChips";

// The asset graph's control row: view switch and forecast on the left, then the controls that narrow what the chart shows on the right. Every control is a toolbar pill so the row reads as one cluster — it used to mix a slate dropdown, a white dropdown and three grey buttons.
const AssetGraphHeaderDesktop = ({
  leadingControl = null,
  viewSchema,
  displayView,
  onViewSelect,
  activeForecast,
  foreCastSchema,
  onForecastSelect,
  forecastVariation,
  onVariationChange,
  onDownloadCSV,
  onOpenTimeRange,
  onOpenDataset,
  selectedTimeRange,
  timeRangeLabel,
}) => {
  const variations = foreCastSchema?.[activeForecast]?.variations || [];

  return (
    /* Wraps rather than crushing: nowrap gave the whole deficit to the forecast select, which hit 0px by 900 */
    <div className="flex flex-row flex-wrap items-center gap-x-3 gap-y-2">
      <div className="flex min-w-0 flex-row flex-nowrap items-center gap-2">
        {/* The page's own control, ahead of the graph's — it opens the asset rail that slides in over this corner, so it has to sit at the row's leading edge */}
        {leadingControl}
        <div data-tour="asset-view" className="shrink-0">
          <TabViewSelect
            viewSchema={viewSchema}
            activeView={displayView}
            onViewSelect={onViewSelect}
          />
        </div>
        {/* Shrinks, but never below a legible width — it carries the longest label on the row */}
        <div data-tour="asset-forecast-desktop" className="min-w-[6rem]">
          <ForecastSelect
            activeForecast={activeForecast}
            foreCastSchema={foreCastSchema}
            onForecastSelect={onForecastSelect}
          />
        </div>
      </div>

      <div className="ml-auto flex min-w-0 flex-row flex-nowrap items-center gap-2">
        <div data-tour="asset-variation-desktop" className="flex items-center">
          <GraphVariationChips
            variations={variations}
            forecastVariation={forecastVariation}
            onVariationChange={onVariationChange}
          />
        </div>

        {onOpenTimeRange && (
          <button
            type="button"
            onClick={onOpenTimeRange}
            data-tour="asset-timerange-desktop"
            aria-label="Select time range"
            className="eai-btn-toolbar"
          >
            <ClockIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
            {/* Kept at every width — it is the only control whose label states the current selection */}
            <span className="max-w-[6rem] truncate xl:max-w-[9rem]">{timeRangeLabel || "Full Range"}</span>
          </button>
        )}

        {onOpenDataset && (
          <button
            type="button"
            onClick={onOpenDataset}
            data-tour="asset-datasets-desktop"
            aria-label="Toggle dataset visibility"
            className="eai-btn-toolbar"
          >
            <DatasetsIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
            {/* Icon-only under xl: the aria-label above still names it, and the row has no room for both labels */}
            <span className="hidden xl:inline">Datasets</span>
          </button>
        )}

        <button
          type="button"
          onClick={onDownloadCSV}
          title="Download CSV"
          aria-label="Download CSV"
          data-tour="asset-download"
          className="eai-btn-toolbar hidden md:inline-flex"
        >
          <DownloadIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
          <span className="hidden xl:inline">Download</span>
        </button>
      </div>
    </div>
  );
};

export default AssetGraphHeaderDesktop;
